(function ($) {

    'use strict';

    const cmpTheme = {

        /**
        *
        * Init all methods and events.
        * "initonReady" method will be called on document ready event/function.
        * 
        * @param {null} null
        * @return {void} void
        */
        initonReady: function () {

            this.stickyHeader();
            this.stickySidebar();
            this.loadVenoBox();
            this.primaryNavigation();
            this.loadCarousel();
            this.backToTop();
            this.ajaxPostLoading();
        },

        /**
        *
        * Sticky Header.
        *
        * @param {null} null
        * @return {void} void
        * @since 1.0.0
        */
        stickyHeader: function () {

            if (cream_magazine_pro_script_obj.enable_sticky_menu_section == '1') {

                switch (cream_magazine_pro_script_obj.header_layout) {
                    case 'header_1':
                        $("nav.main-navigation").sticky();
                        break;
                    case 'header_2':
                        $("nav.main-navigation").sticky();
                        break;
                    case 'header_3':
                        $('.cm_header_lay_two .bottom-header').sticky();
                        break;
                    case 'header_4':
                        $('.cm_header_lay_three .top-header').sticky();
                        break;
                    case 'header_5':
                        $('.navigation-container').sticky();
                        break;
                    default:
                        break;
                }
            }
        },

        /**
        *
        * Sticky Sidebar.
        *
        * @param {null} null
        * @return {void} void
        * @since 1.0.0
        */
        stickySidebar: function () {

            if (cream_magazine_pro_script_obj.enable_sticky_sidebar == '1') {

                $('.sticky_portion').theiaStickySidebar({

                    additionalMarginTop: 10,
                });
            }
        },

        /**
        *
        * Load venobox for lightbox.
        *
        * @param {null} null
        * @return {void} void
        * @since 1.0.0
        */

        loadVenoBox: function () {

            if (cream_magazine_pro_script_obj.enable_video_section == '1') {

                $('.venobox').venobox();
            }
        },

        /**
        *
        * Navigation menu.
        *
        * @param {null} null
        * @return {void} void
        * @since 1.0.0
        */

        primaryNavigation: function () {

            $('.primary-navigation').stellarNav({

                theme: 'dark',
                breakpoint: 991,
                closeBtn: false,
                scrollbarFix: true,
                sticky: false,
            });

            // Header search container.
            if (cream_magazine_pro_script_obj.show_search_icon == '1') {

                $("body").on('click', '.cmp-search-icon-btn', function (event) {

                    event.preventDefault();
                    $(".header-search-container").toggle();
                });
            }

            // Off canvas menu support.
            if (cream_magazine_pro_script_obj.enable_off_canvas_menu == '1') {

                $('#off-canvas-nav .menu-item-has-children > a').after('<button class="sub-toggle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg></button>');

                $('body').on('click', '#off-canvas-nav .sub-toggle', function () {

                    $(this).toggleClass('active-submenu');

                    $(this).siblings('ul.sub-menu').toggleClass('sub-menu-open');

                    if ($(this).hasClass('active-submenu')) {

                        $(this).html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/></svg>');

                    } else {

                        $(this).html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>');
                    }
                });

                $('body').on('click', '.cm-off-canvas-menu-overlay, .cm-off-canvas-menu-close', function () {

                    $('body').removeClass('off-canvas-menu-on');
                });
            }
        },

        /**
        *
        * Load Carousel for sliders.
        *
        * @param {null} null
        * @return {void} void
        * @since 1.0.0
        */

        loadCarousel: function () {

            let rtlCarousel = false;
            $('body').hasClass('rtl') ? rtlCarousel = true : rtlCarousel = false;

            // # Slider 1.
            if (cream_magazine_pro_script_obj.show_news_ticker == '1') {
                $('.ticker_carousel').owlCarousel({
                    items: 1,
                    loop: true,
                    margin: 0,
                    smartSpeed: 4000,
                    nav: true,
                    dots: false,
                    autoplay: true,
                    autoplayTimeout: 3000,
                    autoplayHoverPause: true,
                    mouseDrag: false,
                    touchDrag: false,
                    animateOut: 'slideOutUp',
                    animateIn: 'slideInUp',
                    navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/></svg>'],
                    rtl: rtlCarousel,
                });
            }

            // # Slider 2.
            if (
                cream_magazine_pro_script_obj.enable_video_section == '1' &&
                cream_magazine_pro_script_obj.video_section_layout == 'layout_1'
            ) {
                $('.video_carousel').owlCarousel({
                    items: 3,
                    loop: false,
                    rewind: true,
                    lazyLoad: true,
                    margin: 30,
                    smartSpeed: 1200,
                    nav: true,
                    dots: false,
                    autoplay: true,
                    autoplayTimeout: 7000,
                    autoplayHoverPause: true,
                    navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
                    rtl: rtlCarousel,
                    responsive: {
                        0: {
                            items: 1
                        },
                        400: {
                            items: 1
                        },
                        500: {
                            items: 1
                        },
                        768: {
                            items: 1
                        },
                        992: {
                            items: 2
                        },
                        1024: {

                            items: 3
                        },
                        1200: {

                            items: 3
                        }
                    },
                });
            }

            // # Slider 3.
            $('.widget_seven_carousel').owlCarousel({
                items: 3,
                loop: true,
                lazyLoad: true,
                margin: 30,
                smartSpeed: 800,
                nav: false,
                dots: false,
                autoplay: true,
                autoplayTimeout: 8000,
                autoplayHoverPause: true,
                navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
                rtl: rtlCarousel,
                responsive: {
                    0: {
                        items: 1
                    },
                    400: {
                        items: 1
                    },
                    576: {
                        items: 2,
                        margin: 15,
                    },
                    768: {
                        items: 2,
                        margin: 15,
                    },
                    992: {
                        items: 3
                    },
                    1024: {

                        items: 3
                    },
                    1200: {
                        items: 3
                    }
                },
            });

            // # Slider 4
            $('.middle_widget_six_carousel').owlCarousel({
                items: 2,
                loop: true,
                margin: 30,
                lazyLoad: true,
                smartSpeed: 800,
                nav: true,
                dots: false,
                autoplay: true,
                autoplayTimeout: 8000,
                autoplayHoverPause: true,
                navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
                rtl: rtlCarousel,
                responsive: {
                    0: {
                        items: 1
                    },
                    400: {
                        items: 1
                    },
                    576: {
                        items: 2,
                        margin: 15,
                    },
                    768: {
                        items: 2,
                        margin: 15,
                    },
                    992: {
                        items: 2
                    },
                    1024: {

                        items: 2
                    },
                    1200: {
                        items: 2
                    }
                },
            });

            // # Slider 5
            $('.trending_widget_carousel').owlCarousel({
                items: 1,
                loop: true,
                lazyLoad: true,
                margin: 0,
                smartSpeed: 800,
                nav: false,
                dots: true,
                autoplay: true,
                autoplayTimeout: 6000,
                autoplayHoverPause: true,
                navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
                rtl: rtlCarousel
            });

            // # Slider 6
            if (cream_magazine_pro_script_obj.show_banner_slider == '1') {

                if (cream_magazine_pro_script_obj.banner_layout == 'banner_1') {

                    $('.cm_banner-carousel-one').owlCarousel({
                        items: 2,
                        loop: true,
                        lazyLoad: false,
                        smartSpeed: 800,
                        nav: true,
                        dots: false,
                        autoplay: true,
                        autoplayTimeout: 8000,
                        autoplayHoverPause: true,
                        navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
                        rtl: rtlCarousel,
                        responsive: {
                            0: {
                                items: 1
                            },
                            400: {
                                items: 1
                            },
                            500: {
                                items: 1
                            },
                            768: {
                                items: 2
                            },
                            992: {
                                items: 2
                            },
                            1024: {

                                items: 3
                            },
                            1200: {
                                items: 3
                            }
                        },
                    });
                }

                if (cream_magazine_pro_script_obj.banner_layout == 'banner_2') {

                    $('.cm_banner-carousel-three').owlCarousel({
                        items: 1,
                        loop: true,
                        lazyLoad: false,
                        margin: 0,
                        smartSpeed: 700,
                        nav: true,
                        dots: false,
                        autoplay: true,
                        autoplayTimeout: 6000,
                        autoplayHoverPause: true,
                        navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
                        rtl: rtlCarousel
                    });
                }

                if (cream_magazine_pro_script_obj.banner_layout == 'banner_5') {

                    $('.cm_banner-carousel-five').owlCarousel({
                        items: 1,
                        loop: true,
                        lazyLoad: false,
                        margin: 0,
                        smartSpeed: 800,
                        nav: true,
                        dots: false,
                        autoplay: true,
                        autoplayTimeout: 3000,
                        autoplayHoverPause: true,
                        navText: ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
                        rtl: rtlCarousel
                    });
                }
            }
        },

        /**
        *
        * Back to top button.
        *
        * @param {null} null
        * @return {void} void
        * @since 1.0.0
        */

        backToTop: function () {

            $('body').on('click', '#toTop', function () {

                $("html").animate({ scrollTop: 0 }, 800);
            });

            // Watch for scroll event and show/hide the button.
            $(window).on('scroll', function () {

                $(this).scrollTop() !== 0 ? $('#toTop').fadeIn() : $('#toTop').fadeOut();
            });
        },

        /**
        *
        * Ajax post loading.
        * Includes infinite loading and load more button.
        *
        * @param {null} null
        * @return {void} void
        * @since 1.0.0
        */
        ajaxPostLoading: function () {

            let body = $('body');

            // #1. Infinite loading.
            if (cream_magazine_pro_script_obj.pagination == 'infinte_loading') {

                if ((body.hasClass('archive')) ||
                    (body.hasClass('blog')) ||
                    (body.hasClass('search-results'))
                ) {

                    let loading = false;
                    let pageType = '';
                    let currentPage = parseInt(cream_magazine_pro_script_obj.load_more['current_page']);
                    let scrollHandling = {
                        allow: true,
                        reallow: function () {
                            scrollHandling.allow = true;
                        },
                        delay: 400
                    };

                    if (body.hasClass('blog')) {

                        pageType = 'home-page';
                    }

                    if (body.hasClass('archive')) {

                        pageType = 'archive-page';
                    }

                    if (body.hasClass('search')) {

                        pageType = 'search-page';
                    }

                    $(window).scroll(function () {

                        let hT = $('.cmp-infinite-loading').offset().top,
                            hH = $('.cmp-infinite-loading').outerHeight(),
                            wH = $(window).height(),
                            wS = $(this).scrollTop();

                        if (!loading && scrollHandling.allow) {

                            scrollHandling.allow = false;

                            setTimeout(scrollHandling.reallow, scrollHandling.delay);

                            if (wS > ((hT + hH - wH) - 250)) {

                                loading = true;

                                $.ajax({

                                    url: cream_magazine_pro_script_obj.load_more['ajax_url'],

                                    type: 'POST',

                                    data: {
                                        action: 'cream_magazine_pro_load_posts_action',
                                        nonce: cream_magazine_pro_script_obj.load_more['nonce'],
                                        page: currentPage,
                                        query: cream_magazine_pro_script_obj.load_more['posts'],
                                        page_type: pageType,
                                        layout: cream_magazine_pro_script_obj.layout,
                                        grid_class: cream_magazine_pro_script_obj.grid_class,
                                        thumbnail_size: cream_magazine_pro_script_obj.thumbnail_size
                                    },

                                    success: function (response) {

                                        if (response) {

                                            if (cream_magazine_pro_script_obj.layout == 'list_1') {

                                                $('.post-display-list .section_inner').append(response);
                                            } else {
                                                $('.post-display-grid .section_inner .row').append(response);
                                            }

                                            currentPage++;
                                            loading = false;
                                        } else {
                                            $('.cmp-infinite-loading').hide();
                                        }
                                    },
                                    error: function (error) {

                                        throw new Error(error);
                                    },
                                });
                            }
                        }
                    });
                }
            }

            // #2. Load more button.
            if (cream_magazine_pro_script_obj.pagination == 'button_loading') {

                let pageType = '';
                let currentPage = cream_magazine_pro_script_obj.load_more['current_page'];

                if (body.hasClass('blog')) {

                    pageType = 'home-page';
                }

                if (body.hasClass('archive')) {

                    pageType = 'archive-page';
                }

                if (body.hasClass('search')) {

                    pageType = 'search-page';
                }

                $('body').on('click', '.load-more-btn', function (event) {

                    event.preventDefault();

                    $('.load-more-icon').show();

                    $.ajax({

                        url: cream_magazine_pro_script_obj.load_more['ajax_url'],
                        type: 'POST',
                        data: {
                            action: 'cream_magazine_pro_load_posts_action',
                            nonce: cream_magazine_pro_script_obj.load_more['nonce'],
                            page: currentPage,
                            query: cream_magazine_pro_script_obj.load_more['posts'],
                            page_type: pageType,
                            layout: cream_magazine_pro_script_obj.layout,
                            grid_class: cream_magazine_pro_script_obj.grid_class,
                            thumbnail_size: cream_magazine_pro_script_obj.thumbnail_size
                        },

                        success: function (response) {

                            if (response) {

                                if (cream_magazine_pro_script_obj.layout == 'list_1') {

                                    $('.post-display-list .section_inner').append(response);
                                } else {
                                    $('.post-display-grid .section_inner .row').append(response);
                                }

                                currentPage++;

                            } else {

                                $('.cmp-btn-loading').hide();
                            }

                            $('.load-more-icon').hide();
                        },
                        error: function (error) {

                            throw new Error(error);
                        }
                    });
                });
            }
        }
    }

    $(document).ready(function () {

        cmpTheme.initonReady();
    });
})(jQuery);